export const Role = {
  Admin: "Admin",
  SuperAdmin: "SuperAdmin",
  User: "User",
  Manager: "Manager",
  Client: "Client",
};
